export default __webpack_public_path__ + "static/ak-cached/24h/media/music choice karaoke.61abd202.png";